import { Article } from '~src/types/article'

const article: Article = {
  id: 4,
  date: 'Tue Oct 14 2021 16:05:47 GMT+0200 (Central European Summer Time)',
  title: '"Co to jest?" Stale zgrzewane, dziwer, laminaty. Część 3/3',
  mainPicture: {
    type: 'img',
    src: 'cz3_title',
    description:
      'Na zdjęciu widoczny jest jeden z tzw. twist’ów - to wzór, w którym warstwy stali są skręcone, a następnie rozwalcowane do odpowiednich wymiarów.',
    width: '100%',
    height: '457px',
  },
  content: [
    {
      type: 'subtitle',
      content: 'Część 3/3. Stale zgrzewane, dziwer, laminaty.',
    },
    {
      type: 'p',
      content:
        'Co to właściwie jest, co ‘ma wzory’ a nie jest krystaliczną ‘stalą damasceńską’?',
    },
    {
      type: 'p',
      content:
        'Zakładając, że udało nam się już odlać kawałek stali lub żelaza ale chcielibyśmy zrobić większe narzędzie niż pozwala nam na to wielkość dostępnych elementów, możemy użyć jednej z wdzięczniejszych technik kowalskich - tzw. zgrzewania na gorąco.',
    },
    {
      type: 'p',
      content:
        'Polega to na wykorzystaniu zdolności stali do łączenia się w lite elementy w wysokich temperaturach (bliskich ‘spalenia’). W dużym uproszczeniu, składamy ze sobą dwa elementy stalowe, spawamy/skręcamy drutem, obtaczamy w topnik, grzejemy do wysokiej temp. i ostrożnie prasujemy albo obijamy młotkiem. Po kilku cyklach z wielu kawałków dostajemy jeden lity element stalowy. Świadomie, kontrolowane zgrzewanie skomplikowanych gatunków stali jest sztuką i wymaga specjalistycznej wiedzy, umiejętności i ciężkiego sprzętu. Niemniej podstawowy zgrzew można zrobić za pomocą młotka, większego imadła i nadmuchu z suszarki do włosów.',
    },
    {
      type: 'p',
      content:
        'Proces ten był używany historycznie na wiele sposobów, pozwalał na wykonanie skomplikowanych kształtem narzędzi- np. wideł, obręczy, ogniw łańcuchów. Pozwala na łączenie w ramach jednego elementu stali o różnych właściwościach(miękkie grzbiety, twarde rdzenie - broń, siekiery), współcześnie stosuje się też laminowanie stali węglowych ‘policzkami’ ze stali nierdzewnych. Ten sam proces wykorzystywany był też do oczyszczania stali po wytopach dymarkowych i  odpowiadał za powstawanie warstw w mieczach japońskich. Niemniej, współcześnie wykorzystuje się go głównie do robienia narzędzi, które mają... wzorki. Odpowiednie techniki składania, skręcania, zgniatania i wielokrotnego łączenia warstwowych elementów, pozwalają tworzyć zaskakujące i piękne wzory. Jeśli do procesu użyjemy stali o różnym składzie chemicznym (zwykle różni je ilość chromu albo niklu) to po wytrawieniu wykończonych powierzchni, jeden z gatunków pozostanie jaśniejszy od drugiego. Do zgrzewów specjalnie używa się materiałów, które dadzą możliwie kontrastowy efekt po wykończeniu.',
    },
    {
      type: 'img',
      src: 'cz3_ostrz',
      description:
        'Na ostrzu wyraźnie widoczne są warstwy poszczególnych stali, użytych na wykonanie pakietu zgrzewanego.',
      width: '100%',
    },
    {
      type: 'p',
      content:
        'Techniki zgrzewania dają również pasiaste wzory - fal, słojów, warstw…które przywodzą na myśl historyczną stal damasceńską. Niemniej, najczęściej jest je względnie łatwo rozróżnić, a w przypadku produktów dostępnych na rynku możemy śmiało założyć, że mamy do czynienia po prostu z ładnym ‘zgrzewem’.',
    },
    {
      type: 'p',
      content:
        'Sam proces sprowadza się do zgrzania wielu naprzemiennie ułożonych warstw stali a następnie poddaniu ich serii zgięć, cięć, skręceń, uderzeń, kolejnych złożeń i zgrzań… niektóre wzory wymagają kilkukrotnego cięcia pierwotnego pakietu i ponownego zgrzewania w nowych ustawieniach(np. szewron, wzory geometryczne).',
    },
    {
      type: 'p',
      content:
        'Specami od wykorzystywania zgrzewania do produkcji zdobionych ostrzy byli już Rzymianie, niemniej współcześnie poszliśmy dużo dalej. Warto przejrzeć wyszukiwania googla pod hasłem ‘Pattern welded steel’ - myślę, że kulturowo zbliżamy się do granic absurdu w opanowaniu tej techniki ( damasty mozaikowe - napisy)  :)',
    },
    {
      type: 'p',
      content:
        'Na co warto zwrócić uwagę, damasty zgrzewane najczęściej wytwarzane są z gatunków stali, które jest względnie łatwo zgrzewać, czyli niekoniecznie z gatunków o dobrych właściwościach narzędziowych. Nie wszystko co ma wzór na powierzchni jest tym samym materiałem. Jakość ostatecznego narzędzia będzie zależała od tego jakie gatunki zostały użyte jako startowe. Współcześnie jakość materiału otrzymywanego z huty i będącego startowym materiałem do wykonywania pakietów stali zgrzewanych, są tak czyste i tak dobrej jakości, że głównym zadaniem twórcy jest próba nie pogorszenia ich właściwości w trakcie obróbki. Bardzo niewdzięcznym tematem jest zgrzewanie stali nierdzewnych i stopowych, które wymagają dużych nacisków pras czy atmosfer ochronnych, a które są bardzo dobrymi materiałami narzędziowymi. Nieumiejętna obróbka skomplikowanych stali stopowych może pogorszyć ich właściwości(np. przez rozrost ziarna występujących przy częstym wygrzewaniu, odwęglenia, rozrost węglików, pęknięcia). Niemniej są ludzie i firmy mające masę doświadczenia i odpowiedni sprzęt, którzy radzą sobie z bardzo skomplikowanymi gatunkami. Każde zestawienie trudniejszych gatunków wymaga opracowania odpowiedniego procesu, dopasowanego do ich specyfiki.',
    },
    {
      type: 'p',
      content:
        'Często kiedy rozmawia się z ludźmi o stalach zgrzewanych, pada pytanie : “ A ile one mają warstw? “ z milczącym domniemaniem, że jak dużo warstw to lepsze, niż jeśli mało. Natomiast o ile miało to pewien sens historycznie(o czym w cz. 1), o tyle współcześnie nie ma to żadnego przełożenia na jakość narzędzia. Wiele z bardziej skomplikowanych wzorów ma tak poskręcane i poprzekładane układy warstw, że są one właściwie niepoliczalne. Tak jest np. we wszystkich ‘twistach’, gdzie pakiet jest skręcony wokół osi ostrza - warstwy idą wtedy niemal  ‘w poprzek’. W związku z powyższym, przy ocenianiu współczesnych stali zgrzewanych wypadałoby ograniczyć się do stwierdzeń typu : ‘ Bardzo ładny wzór!” “pięknie udało się zachować symetrię i układ warstw” - ocena estetyczna jest jedyną jaką można przeprowadzić ‘na oko’. ',
    },
    {
      type: 'p',
      content:
        'W przypadku noży, warto też sprawdzić jaki materiał jest w ‘rdzeniu’ ostrza - to ten materiał będzie faktycznie ciął, a cała reszta jest dla ozdoby. W przypadku damastów zgrzewanych, robionych ze stali narzędziowych często na krawędzi tnącej pojawia się wynikająca ze wzoru mieszanka gatunków użytych do pakietu, jeśli oba gatunki mają dobre właściwości to mogą to być bardzo solidne ostrza. Na rynku jest też sporo atrakcyjnie wyglądających ostrzy, o konstrukcji trójwarstwowej, w których ‘boki’ są zrobione z wzorzystych pakietów, a rdzeń jest z litego materiału - najczęściej o znacznie lepszych właściwościach niż reszta ostrza. 3 warstwowe laminaty są od wieków obecne w tradycji Japońskiej, gdzie stal o największej twardości wstawiana jest jako rdzeń, a ‘policzki’ robione są z miększych gatunków. Miało to historycznie sens zarówno ekonomiczny - mniej drogiego materiału zużywana jest na ostrze, jak i praktyczny - przy ostrzeniu, miękki materiał ściera się dużo łatwiej, w związku z czym łatwiej wyprowadzać wysokie szlify ( japońskie noże ostrzy się inaczej niż noże zachodnie).',
    },
    {
      type: 'p',
      content:
        'Opcji zestawień różnych gatunków i wzorów jest masa, natomiast współcześnie dostęp do stali wysokiej jakości jest na tyle łatwy, a ich ceny na tyle przystępne, że każdy dodatkowy ruch wykonywany na ostrzach nie prowadzi wprost do poprawy żadnej z ich właściwości funkcjonalnych. Jeśli zależy nam na czystej funkcjonalności to należy odłożyć wszelkie wzorzyste ostrza i postarać się o możliwie dobrej jakości lity materiał.',
    },
    {
      type: 'p',
      content:
        'Szczęśliwie nie wszystkim ludziom zależy na czystej funkcjonalności i dzięki temu Świat jest znacznie ciekawszy :). Wiele współczesnych ostrzy zgrzewanych można traktować jak ważne wytwory kultury, będące wizytówką estetycznych i technologicznych możliwości wytwarzających je Atystów(rzemieślników). Ale jest to też wizytówka wrażliwości i zaangażowania odbiorców takich narzędzi. Kwestia ‘krojenia marchewki’ została rozwiązana w sposób wystarczający już wiele lat temu, stąd niekończące się rozmowy o tym ‘co lepiej pokroi’ zwykle są bezzasadne, zadbane ostrze z ‘czegokolwiek’ pokroi wystarczająco dobrze.',
    },
    {
      type: 'p',
      content:
        'Pryzmat czystej funkcjonalności nie jest jedynym pryzmatem, który warto wziąć pod uwagę, szczególnie poszukując wartości wznoszącej się ponad ‘marchewkę’.',
    },
    {
      type: 'p',
      content:
        'Jakkolwiek próżnym może się wydawać poświęcanie mnóstwa czasu i energii na czyste ‘zdobnictwo’, to idzie za tym przynajmniej jedna pozytywna myśl. To myśl, która może pozwolić nam trochę inaczej spojrzeć na przedmioty, którymi się otaczamy i sprawić, że będziemy potrzebowali mniej i rzadziej.',
    },
    {
      type: 'p',
      content:
        'Na przestrzeni już ładnych paru lat wytwarzania noży, coraz mocniej utwierdzam się w przekonaniu, że kluczowym elementem dotyczącym wytwarzania narzędzi jest odpowiednia świadomość ich użytkowników. Ich podejście do przedmiotu, szacunek, dbałość i utrzymywanie go w dobrej kondycji, są jedynym gwarantem korzystania z pełni możliwości narzędzia. Zadbany nóż z pospolitej stali będzie kroił lepiej niż zaniedbany z kosmicznego materiału.',
    },
    {
      type: 'p',
      content:
        'Idąc tym tropem, przedmioty, które budzą w ludziach pozytywne emocje, uznanie dla rzemiosła twórcy, czy personalnie angażujące przez indywidualne wykończenia, mogą liczyć na więcej uwagi i troski - a co za tym idzie, będą lepiej i dłużej służyć. Dlatego, jeśli pasiaste wzory powstające na ostrzach wykonanych ze stali zgrzewanych, budzą w kimś dobre emocje, to można spodziewać się, że narzędzie z nich wykonane - będzie bardziej zadbane i pielęgnowane - a przez to będzie Wam służyć dłużej i lepiej. :)',
    },
    {
      type: 'p',
      content:
        'Tym optymistycznym akcentem kończymy obszerny materiał dot. stali - byliście bardzo dzielni :)',
    },

    {
      type: 'subtitleGray',
      content: 'Źródła:',
    },

    {
      type: 'sourceLink',
      preffix: 'The art of Japanese Swords /',
      href:
        'https://books.google.pl/books?id=URDQAgAAQBAJ&printsec=frontcover#v=onepage&q&f=false',
    },

    {
      type: 'sourceLink',
      preffix: 'Nanorurki węglowe w damaście ',
      href:
        'https://www.nationalgeographic.com/science/phenomena/2008/09/27/carbon-nanotechnology-in-an-17th-century-damascus-sword/',
    },
    {
      type: 'sourceLink',
      preffix:
        'Dużo o stali i różnicach w mieczach - szkielet myślenia dla całego artykułu.',
      href: 'https://www.youtube.com/watch?v=5djVkOgu8vs&t=1305s',
    },
    {
      type: 'sourceLink',
      preffix: 'Proces wyrobu katany - skrócony :)',
      href: 'https://www.youtube.com/watch?v=Q598DP27tGA',
    },
    {
      type: 'sourceLink',
      preffix: 'Praca o stali damasceńskiej Pendray i Verhoeven',
      href: 'https://www.tms.org/pubs/journals/JOM/9809/Verhoeven-9809.html',
    },
    {
      type: 'sourceLink',
      preffix: 'Patent Pendray i Verhoeven',
      href: 'https://patents.google.com/patent/US5185044A/en',
    },
    {
      type: 'sourceLink',
      preffix: 'Historie o cudownych właściwościach dmastu',
      href:
        'https://books.google.pl/books?id=bVsFAAAAQAAJ&pg=RA1-PA508&lpg=RA1-PA508&dq=damascus+blade+flexibility+test&source=bl&ots=ol3Fg-fbbG&sig=ACfU3U1u2pnIKCPe3IdompgHWPsYWvDtcQ&hl=en&sa=X&ved=2ahUKEwikpfbp4NjpAhWrwsQBHS0RAEEQ6AEwG3oECAYQAQ#v=onepage&q=damascus%20blade%20flexibility%20test&f=false',
    },
    {
      type: 'sourceLink',
      href: 'https://en.wikipedia.org/wiki/Talk%3AWootz_steel',
    },
    {
      type: 'sourceLink',
      href:
        'https://polishcustomknives.pl/blog/pierwiastki-w-stali-czesc-druga-domieszki-w-stali.html',
    },
    {
      type: 'sourceLink',
      href: 'https://pl.wikipedia.org/wiki/Stop_%C5%BCelaza_z_w%C4%99glem',
    },
    {
      type: 'sourceLink',
      href: 'https://en.wikipedia.org/wiki/Steelmaking',
    },
    {
      type: 'sourceLink',
      href: 'https://en.wikipedia.org/wiki/Bessemer_process',
    },
    {
      type: 'sourceLink',
      href: 'https://www.britannica.com/technology/wrought-iron',
    },
    {
      type: 'sourceLink',
      href:
        'https://en.wikipedia.org/wiki/File:Watered_pattern_on_sword_blade1.Iran.JPG',
    },
    {
      type: 'sourceLink',
      href: 'http://www.pg.gda.pl/~kkrzyszt/stopy_zelaza_cz1_PIM.pdf',
    },
    {
      type: 'sourceLink',
      href:
        'https://figel.pl/wiedza/technologia-spawania/zawartosc-stali-a-jej-wlasnosci/',
    },
    {
      type: 'subtitleGray',
      content: 'Zdjęcia:',
    },
    {
      type: 'sourceLink',
      preffix: '',
      href: 'https://ravencresttactical.com/all-about-samurai-steel/',
    },

    {
      type: 'sourceLink',
      preffix: '(tatara)',
      href:
        'https://japan-forward.com/wp-content/uploads/2018/12/%E2%80%98tatara-watetsu%E2%80%99-japanese-town-revives-traditional-steel-production.jpg',
    },

    {
      type: 'p',
      content: 'Materiały własne - KŁOSY.',
    },
  ],
}

export default article
